module.exports = __webpack_public_path__ + "static/media/chose-app.bbf0a7ce.svg";